// @flow
import React, {Component} from 'react';
import {Checkbox} from '@homeaway/react-form-components';

import {isEqual} from 'lodash';

/* istanbul ignore next */
export type Refinement = {
    name: string,
    key: string,
    count: number
};

type Props = {
    filters: Refinement[],
    groupName: string,
    handleChecked: (SyntheticEvent<HTMLInputElement>) => void,
    checked: string[]
};

const isFilterChecked = (checked: string[], filterKey: string): boolean => {
    return checked.includes(filterKey);
};

const checkedInGroup = (checked: string[], filters: Refinement[]): string[] => {
    const keysInGroup = filters.reduce((prev: Object, cur: Refinement) => {
        prev[cur.key] = true;
        return prev;
    }, {});

    const filtered = checked.filter((c) => keysInGroup[c]);
    filtered.sort();
    return filtered;
};

const canonicalizeFilters = (filters: Refinement[]) =>
    filters.map((f) => ({...f, count: f.count > 0 ? 1 : 0}));

export class FilterGroup extends Component<Props> {
    /**
     * We only update if the checked filters in the group changes or if any of the counts of the filters changes from non-zero to zero and vice versa
     * @param {Props} nextProps
     */
    shouldComponentUpdate(nextProps: Props) {
        const nextFilters = nextProps.filters;
        const nextChecked = nextProps.checked;
        const {filters, checked} = this.props;

        return (
            !isEqual(
                canonicalizeFilters(nextFilters),
                canonicalizeFilters(filters)
            ) ||
            !isEqual(
                checkedInGroup(checked, filters),
                checkedInGroup(nextChecked, filters)
            )
        );
    }

    render() {
        const {filters, groupName, handleChecked, checked} = this.props;

        return (
            <div className="FilterGroup">
                <h2 className="FilterGroup__label">{groupName}</h2>
                {filters.map((filter) => {
                    const filterKey = filter.key;
                    const isChecked = isFilterChecked(checked, filterKey);
                    const isDisabled = !isChecked && filter.count <= 0;
                    return (
                        <Checkbox
                            data-wdio={`checkbox__${filterKey}`}
                            key={filterKey}
                            name={filterKey}
                            checked={isChecked}
                            label={filter.name}
                            onChange={handleChecked}
                            disabled={isDisabled}
                        />
                    );
                })}
            </div>
        );
    }
}

export default FilterGroup;
